import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Snackbars from '../pages/Snackbars';
import validator from 'validator';
import { useTranslation } from "react-i18next";
import axios from 'axios';

function LoginDemo(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [email_error, setEmailError] = useState("");
  const [error, setError] = useState(false);
  // const [success, setSuccess] = useState(false);
  const [error_msg, setErrorMsg] = useState("");
  // const [success_msg, setSuccessMsg] = useState("");

  const [logo, setLogo] = useState("");

  useEffect(() => {
    window.sessionStorage.removeItem("register_user_id");
    window.sessionStorage.removeItem("temp_login_id");
    if (window.sessionStorage.getItem("user_id")) {
      history.push('/dashboard');
    }

    if (window.sessionStorage.getItem("user_jwt")) {
      history.push('/dashboard');
    }

    handlelogo();
  }, [history]);

  const handlelogo = () => {
    const headers = {
      'Content-Type': 'application/json',
      'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
    }
    axios.get(process.env.REACT_APP_API_URL + 'getalllogo', { headers: headers })
      .then(function (res) {
        res = res.data;
        if (res.code === "200") {
          console.log(process.env.REACT_APP_FILE_PATH_LOGO + res.data.whitelogo);
          setLogo(process.env.REACT_APP_FILE_PATH_LOGO + res.data.whitelogo);
        }

      })
      .catch(function (error) {

      });
  }


  const validateEmail = (value) => {
    // window.sessionStorage.setItem("languagesession", "en");
    // i18next.changeLanguage(window.sessionStorage.getItem("languagesession"));
    setEmail(value);
    if (validator.isEmail(value)) {
      setEmailError("");
      return true;
    } else {
      setEmailError(t('ERROR_MSG.CORRECT_EMAIL'));
      return false;
    }
  }


  const handlesubmit = () => {
    if (validateEmail(email) === false) {
      setEmailError(t('ERROR_MSG.CORRECT_EMAIL'));
      return false;
    } else {
      setEmailError('');
      document.getElementById("submit").disabled = true;
      document.getElementById("submit").textContent = t('PROCESSING');
      var jsonpar = JSON.stringify({
        'email_id': email,
      });
      const headers = {
        'Content-Type': 'application/json',
        'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
      }
      axios.post(process.env.REACT_APP_API_URL + 'logindemo', jsonpar, { headers: headers })
        .then(function (res) {
          res = res.data;
          if (res.code === "200") {
            window.sessionStorage.setItem("temp_login_id", res.data);
            history.push('/register-verify-otpdemo');
          } else if (res.code === "4012") {
            window.sessionStorage.setItem("register_user_id", res.data);
            history.push('/register-google-authdemo');
          } else if (res.code === "401") {
            document.getElementById("submit").disabled = false;
            document.getElementById("submit").textContent = t('BUTTONS.SUBMIT');
            setError(true);
            setErrorMsg(res.message);
            setTimeout(() => {
              setError(false);
            }, 6000);
          }

        })
        .catch(function (error) {
          document.getElementById("submit").disabled = false;
          document.getElementById("submit").textContent = t('BUTTONS.SUBMIT');
          setError(true);
          setErrorMsg(t('ERROR_MSG.SOMETHING'));
          setTimeout(() => {
            setError(false);
          }, 6000);
        });
    }
  }


  return (
    <div className="vh-100 login-main-page">
      {error ? <Snackbars open_close={error} type="error" message={error_msg} /> : ""}
      <div className="row m-0 justify-content-center h-100 align-items-center">
        <div className="login-wrapper">
          <div className="login-aside-right">
            <div className="col-xl-12">
              <div className="authincation-content">
                <div className="row no-gutters">
                  <div className="col-xl-12">
                    <div className="auth-form-1">
                      <div className="mb-5">
                        <Link to="/login" className="login-logo1 logo-center">
                          <img src={logo} alt="" className='mb-4 logo' />
                        </Link>
                        <h4 className="text-white mb-1 text-center login-text"> {t('LOGIN_PAGE_TITLE')}</h4>
                      </div>

                      <div className="form-group">
                        <label className="mb-2 ">
                          <span className="text-white">{t('LABEL.LABEL_EMAIL')}</span>
                        </label>
                        <input type="email" value={email} onChange={(e) => validateEmail(e.target.value)} className="form-control text-black" placeholder={t('PLACEHOLDER.PLACEHOLDER_EMAIL')} />
                        {email_error !== "" ? <label className='text-red'>{email_error}</label> : ""}
                      </div>
                      <div className="text-center mt-4">
                        <button type="button" id="submit" onClick={handlesubmit} className="btn btn-login-hover bg-white text-primary btn-block" >{t('BUTTONS.LOGIN_BUTTON')}  </button>
                      </div>

                      <div className="new-account mt-5">
                        <p className="text-white text-center"> {t('DONT_HAVE_ACCOIUNT')} <Link className="text-white color-bg-link" to="./demorequest"> {t('BUTTONS.SIGNUP_BUTTON')} </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default LoginDemo;